<template>
  <section>
    <ServicesTopBar />
    <Recommendations />
    <SiteFooter />
  </section>
</template>

<script>
import ServicesTopBar from '../components/services/ServicesTopBar.vue'
import Recommendations from '../components/services/Recommendations.vue'
import SiteFooter from '../components/site/SiteFooter.vue'

export default {
  components: { ServicesTopBar, Recommendations, SiteFooter },
}
</script>

<style scoped>

</style>
